import { ReactNode, useContext, useEffect, useState } from "react";
import { Box, BoxProps } from "../Box";
import { TabsContext } from "./contexts/TabsContext";

export type TabContentProps<TValue extends string | number = string> = {
  value: TValue;
  children: ReactNode;
} & Omit<BoxProps, "children">;

export const TabContent = <TValue extends string | number = string>({
  value,
  children,
  ...props
}: TabContentProps<TValue>) => {
  const { activeValue } = useContext(TabsContext);

  const [hasMounted, setHasMounted] = useState(activeValue === value);

  useEffect(() => {
    if (!hasMounted && activeValue === value) {
      setHasMounted(true);
    }
  }, [activeValue, value]);

  if (!hasMounted) {
    return null;
  }

  return (
    <Box
      role="tabpanel"
      {...props}
      css={{ display: activeValue === value ? "block" : "none", height: "100%", ...props.css }}
    >
      {children}
    </Box>
  );
};

TabContent.displayName = "TabContent";
